import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  TextField,
  Button,
  Typography,
  Avatar,
  Stack,
  CircularProgress,
} from "@mui/material";
import { LockOutlined as LockIcon } from "@mui/icons-material";
import api from "../services/api";
import { toast } from "react-toastify";

export default function Login() {
  const navigate = useNavigate();
  const [data, setData] = useState({
    AdminUsername: "",
    AdminPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (data.AdminUsername === "" || data.AdminPassword === "") {
      return toast.error("Please fill in all fields");
    }
    setLoading(true);
    try {
      let res = await api.post("/AdminLogin", data);
      if (res.data.data) {
        toast.success(res.data.message);
        localStorage.setItem("login", true);
        navigate("/admin/Products");
      } else {
        toast.warning(res.data.message);
      }
    } catch (err) {
      toast.error("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f5f7fa",
        p: 3,
      }}
    >
      <Card
        sx={{
          maxWidth: 480,
          width: "100%",
          p: 4,
          borderRadius: 3,
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        }}
      >
        {/* Header */}
        <Stack spacing={2} alignItems="center" sx={{ mb: 4 }}>
          <Avatar
            sx={{
              width: 64,
              height: 64,
              bgcolor: "#1a237e",
              boxShadow: "0 4px 12px rgba(26,35,126,0.3)",
            }}
          >
            <LockIcon sx={{ fontSize: 32 }} />
          </Avatar>
          <Box textAlign="center">
            <Typography variant="h4" fontWeight="bold" color="#1a237e" gutterBottom>
              Admin Login
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Sign in to access the admin panel
            </Typography>
          </Box>
        </Stack>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              label="Username"
              name="AdminUsername"
              value={data.AdminUsername}
              onChange={handleChange}
              required
              autoFocus
              placeholder="Enter your username"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#1976d2",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1976d2",
                  },
                },
              }}
            />
            <TextField
              fullWidth
              label="Password"
              name="AdminPassword"
              type="password"
              value={data.AdminPassword}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#1976d2",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1976d2",
                  },
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                bgcolor: "#1976d2",
                py: 1.5,
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 600,
                boxShadow: "0 4px 12px rgba(25,118,210,0.3)",
                "&:hover": {
                  bgcolor: "#1565c0",
                  boxShadow: "0 6px 16px rgba(25,118,210,0.4)",
                },
              }}
            >
              {loading ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                  <span>Logging in...</span>
                </Stack>
              ) : (
                "Login"
              )}
            </Button>
          </Stack>
        </form>

        {/* Footer */}
        <Box sx={{ mt: 3, textAlign: "center" }}>
          <Typography variant="caption" color="text.secondary">
            Protected area - Authorized access only
          </Typography>
        </Box>
      </Card>
    </Box>
  );
}
